const removeTrailingSlash = (value: string) => {
  if (value.endsWith("/")) {
    return value.substring(0, value.length - 1);
  }
  return value
}

export default removeTrailingSlash